import React from 'react';
import './AudiencesSyncRestrictionsModal.pcss';
import { ModalBody, ModalHeader } from '../modal-helpers';
import { PrimaryButton } from '../../buttons/PrimaryButton/PrimaryButton';

const helpdocLink =
  'https://customers.ai/help/article/gaokil4hqj-how-to-claim-your-ad-account-in-business-manager';

type Props = {
  error: string;
  closeModal: () => void;
};

export const AudiencesSyncRestrictionsModal = (props: Props) => {
  const { error, closeModal } = props;

  return (
    <div className="audiences-sync-restrictions-modal">
      <ModalHeader
        className="audiences-sync-restrictions-modal__header"
        childrenContainerClassName="audiences-sync-restrictions-modal__heading"
      >
        Audience sync error
      </ModalHeader>
      <ModalBody className="audiences-sync-restrictions-modal__body">
        <p className="audiences-sync-restrictions-modal__body-note">
          In order to use custom audiences to exclude unsubscribers from your
          Sponsored Message, your ad account needs to be claimed by a business.
          See{' '}
          <a
            className="audiences-sync-restrictions-modal__helpdoc-link"
            href={helpdocLink}
            target="_blank"
          >
            this help doc
          </a>{' '}
          for further instructions.
        </p>
        <div className="audiences-sync-restrictions-modal__extra-details-wrapper">
          <div className="audiences-sync-restrictions-modal__extra-details-title">
            Error details
          </div>
          <div className="audiences-sync-restrictions-modal__extra-details">
            {error}
          </div>
        </div>
        <div className="audiences-sync-restrictions-modal__button-container">
          <PrimaryButton
            className="audiences-sync-restrictions-modal__next"
            onClick={closeModal}
          >
            Ok
          </PrimaryButton>
        </div>
      </ModalBody>
    </div>
  );
};
